export const languageFilter = {
  "heading": "Language",
  "data": [
    {
      "key": "english",
      "label": "English"
    },
    {
      "key": "hindi",
      "label": "Hindi"
    },
    {
      "key": "telugu",
      "label": "Telugu"
    }
  ]
}

export const genreFilter = {
  "heading": "Genre",
  "data": [
    {
      "key": "art",
      "label": "Art"
    },
    {
      "key": "music",
      "label": "Music"
    },
    {
      "key": "literature",
      "label": "Literature"
    },
    {
      "key": "Fiction",
      "label": "Fiction"
    },
    // {
    //   "key": "Business & Economics",
    //   "label": "Business & Economics"
    // },
    {
      "key": "Science",
      "label": "Science"
    },
    // {
    //   "key": "Body, Mind & Spirit",
    //   "label": "Body, Mind & Spirit"
    // },
    // {
    //   "key": "Bhagavadgītā",
    //   "label": "Bhagavadgītā"
    // },
    // {
    //   "key": "Juvenile Fiction",
    //   "label": "Juvenile Fiction"
    // },
    {
      "key": "Self-Help",
      "label": "Self-Help"
    },
    {
      "key": "Travel",
      "label": "Travel"
    },
    // {
    //   "key": "Business & Economics",
    //   "label": "Business & Economics"
    // },
    {
      "key": "Yoga",
      "label": "Yoga"
    },
  ]
}

export const sortOptions = [
  {
    "key": "asc",
    "label": "Price - Low to High"
  },
  {
    "key": "desc",
    "label": "Price - High to Low"
  },
  // {
  //   "key": "desc",
  //   "label": "Newest First"
  // }
]